import Link from "next/link";
import Image from "next/image";
import Tweet from "react-tweet-embed";

import ProsCard from "~/components/ProsCard";
import ConsCard from "~/components/ConsCard";
import Step from "~/components/Step";
import HitRecord from "~/components/HitRecord";
import LightningMachine from "~/components/LightningMachine";
import LongExposure from "~/components/LongExposure";
import NeonCity from "~/components/NeonCity";
import DeepDive from "~/components/DeepDive";
import InferenceAnimation from "~/components/InferenceAnimation";
import Question from "~/components/Question";
import ResidualStreamDiagram from "~/components/ResidualStreamDiagram";

const CustomLink = (props) => {
  const href = props.href;
  const isInternalLink = href && (href.startsWith("/") || href.startsWith("#"));

  if (isInternalLink) {
    return <Link href={href} {...props}></Link>;
  }

  return <a target="_blank" rel="noopener noreferrer" {...props} />;
};

const MDXComponents = {
  Image,
  a: CustomLink,
  HitRecord,
  ConsCard,
  LightningMachine,
  LongExposure,
  NeonCity,
  DeepDive,
  InferenceAnimation,
  ProsCard,
  Question,
  ResidualStreamDiagram,
  Step,
  Tweet
};

export default MDXComponents;
